<template>
    <div class="main">
        <c-panel title="REGRAS DE INFREQUÊNCIA" titleIcon="fas fa-user-clock">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Define quando um aluno entra na busca ativa."
                description="A janela é contada em DIAS LETIVOS da escola — feriados, recessos e pontos facultativos não entram na contagem."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="10">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar regra..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8">
                    <el-select v-model="filtro.periodo_letivo_id" clearable placeholder="Período letivo" style="width: 100%;" @change="carregar">
                        <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/regra-infrequencia/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA REGRA</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Regra</th>
                            <th>Gatilho</th>
                            <th style="width: 110px;">Escopo</th>
                            <th style="width: 110px;" class="u-text-center">Severidade</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="r in items" :key="r.id">
                            <td>
                                {{ r.nome }}
                                <div>
                                    <el-tag v-for="a in (r.acoes || [])" :key="a" size="mini" class="u-mr-5">{{ rotuloAcao(a) }}</el-tag>
                                </div>
                            </td>
                            <td>{{ r.descricao_gatilho }}</td>
                            <td>{{ r.escopo === 'rede' ? 'Rede' : 'Escola' }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="corSeveridade(r.severidade)">{{ r.severidade }}</el-tag>
                            </td>
                            <td class="u-text-center">{{ r.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/regra-infrequencia/edit/' + r.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(r.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhuma regra cadastrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO I — item 131. Interface para `api/regra-infrequencia`. */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({ statusList: false, filtro: { nome: '', periodo_letivo_id: '' }, items: [] }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''
        this.carregar()
    },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        corSeveridade (s) { return { baixa: 'info', media: 'warning', alta: 'danger' }[s] || 'info' },
        rotuloAcao (a) {
            return { alerta_painel: 'Painel', notificar_responsavel: 'Notificar',
                abrir_intervencao: 'Intervenção', notificar_conselho_tutelar: 'Conselho Tutelar' }[a] || a
        },
        excluir (id) {
            this.$confirm('Excluir esta regra?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/regra-infrequencia/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Regra excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
